import { render, staticRenderFns } from "./PendenciaNegociacao.vue?vue&type=template&id=9dd7ca00&"
import script from "./PendenciaNegociacao.vue?vue&type=script&lang=js&"
export * from "./PendenciaNegociacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/PendenciaNegociacao.vue
// module id = 106
// module chunks = 28